export const ImageSize = {
    country: {
        ratio: 2,
        minWidth: 128,
        maxWidth: 256,
        minHeight: 64,
        maxHeight: 128
    },
    avatar: {
        ratio: 1,
        minWidth: 128,
        maxWidth: 512,
        minHeight: 128,
        maxHeight: 512
    },
}
